module.exports = __webpack_public_path__ + "images/macbook-en@2x-e14572.png";